import { getOfflineDatabase } from "../offline/database.js";
import { initialDisasterSession, isDisasterSession } from "./machine.js";
import type { DisasterSession } from "./machine.js";

const activeSessionKey = "active-disaster-flow";

export async function loadDisasterSession(): Promise<DisasterSession> {
  const database = await getOfflineDatabase();
  const record = await database.get("disasterSessions", activeSessionKey);
  return isDisasterSession(record?.session) ? record.session : initialDisasterSession;
}

export async function saveDisasterSession(session: DisasterSession): Promise<void> {
  const database = await getOfflineDatabase();
  await database.put(
    "disasterSessions",
    { key: activeSessionKey, session, updatedAt: new Date().toISOString() },
    activeSessionKey,
  );
}

export async function clearDisasterSession(): Promise<void> {
  const database = await getOfflineDatabase();
  await database.delete("disasterSessions", activeSessionKey);
}
